import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '@delon/theme';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';
import { JyUserService } from '../../../../routes/jy-authorization/user/jy-user.service';
import { JyMessageService } from '../../../../routes/jy-message/jy-message.service';
import { PersonService } from '../../../../routes/jy-org/person/service/person.service';

@Component({
  selector: 'header-user',
  template: `
    <nz-dropdown nzPlacement="bottomRight">
      <div class="alain-default__nav-item d-flex align-items-center px-sm" nz-dropdown>
        <nz-avatar *ngIf="!personService.currentPerson.headImage" nzIcon="anticon anticon-user"
                   style="background-color:#87d068;" nzSize="small" class="mr-sm">
        </nz-avatar>
        <img style="margin-right: 7px" *ngIf="personService.currentPerson.headImage" [attachment-src]="personService.currentPerson.headImage" error-src width="24px" height="24px">
        {{settings.user.name}}
      </div>
      <div nz-menu class="width-sm">
        <div nz-menu-item><i class="anticon anticon-user mr-sm"></i><a style="display: inline"
                                                                       routerLink="/system-msg/log">{{'personCenter' | translate}}</a>
        </div>
        <li nz-menu-divider></li>
        <div nz-menu-item><i class="anticon anticon-setting mr-sm"></i><a style="display: inline"
                                                                          routerLink="/authorization/userInfo">{{'personSetting' | translate}}</a>
        </div>
        <div nz-menu-item [nzDisabled]="true" [hidden]="true"><i
          class="anticon anticon-setting mr-sm"></i>{{'set' | translate}}
        </div>
        <li nz-menu-divider></li>
        <div nz-menu-item (click)="logout()"><i class="anticon anticon-logout mr-sm"></i>{{'exit' | translate}}</div>
      </div>
    </nz-dropdown>
  `,
})
export class HeaderUserComponent {
  constructor(
    private jyUserService: JyUserService,
    public settings: SettingsService,
    private router: Router,
    private jyMessageService:JyMessageService,
    public personService:PersonService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
  ) {
  }
  logout() {
    this.jyUserService.logout({}).subscribe();
    this.tokenService.clear();
    this.router.navigateByUrl(this.tokenService.login_url);
  }
}
